import React from 'react'
import ContentfulJsonLdBlocks from 'src/components/shared/ContentfulJsonLdBlocks'
import Layout from 'src/components/layouts'
import ScamPage from 'src/components/pages/BrandPages/Scam'
import { getMegamenuData } from 'src/common/back/megamenu'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'

export async function getServerSideProps(context) {
  const jsonLdSchemas = await getContentfulJsonLd('scam/')
  let megamenuData = null
  try {
    megamenuData = await getMegamenuData(context)
  } catch (error) {}

  return {
    props: {
      megamenuData: megamenuData || null,
      jsonLdSchemas,
    },
  }
}

const Scam = ({ megamenuData, jsonLdSchemas }) => {
  return (
    <>
      <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
      <Layout
        crawlable={true}
        isBrandPage={true}
        footerClassName="mb-5 lg:mb-0"
        dashboardClass="bg-blue-300 text-white"
        megamenuData={megamenuData}
      >
        <ScamPage />
      </Layout>
    </>
  )
}

export default Scam
